<template>
  <form class="adv-product-page-signature" ref="schemaForm">
    <div class="adv-product-page-signature-container">
      <label class="toggle-switch" for="signature">
        <span class="checkbox-round-text">{{ signatureName }}:</span>
        <input
          type="checkbox"
          class="checkbox-round"
          id="signature"
          name="signature"
          value="1"
          v-model="signature"
        />
        <span class="slider-round"></span>
      </label>
    </div>
    <div v-if="signature" class="adv-product-page-signature-inputs">
      <div class="adv-product-page-signature-radio-buttons">
        <label class="custom-radio-dioptra" for="general">
          <input
            name="description"
            value="general"
            type="radio"
            id="general"
            class="custom-control-input"
            v-model="selection"
          />
          <span class="checkmark"></span>
          <span class="custom-radio-dioptra-text">{{ generalDedicationText }}</span>
        </label>
        <label class="custom-radio-dioptra" for="specific">
          <input
            name="description"
            value="specific"
            type="radio"
            id="specific"
            class="custom-control-input"
            v-model="selection"
          />
          <span class="checkmark"></span>
          <span class="custom-radio-dioptra-text">{{ nominalDedicationText }}</span>
        </label>
      </div>
      <div v-if="selection === 'specific'" class="adv-product-page-signature-input-wrapper">
        <label for="description" class="adv-product-page-signature-input-text">Όνομα αφιέρωσης:</label>
        <div class="adv-product-page-signature-input-container">
          <input
            type="text"
            id="description"
            class="adv-product-page-signature-input"
            name="description"
            :maxlength="maxCharacters"
            :placeholder="placeholder"
            minlength="2"
            v-model="rawInput"
            required
          />
          <button type="button" class="adv-product-page-signature-input-clear-button" @click="clearInput">&times;</button>
        </div>
        <span class="adv-product-page-signature-input-submit-button">Καταχώρηση</span>
      </div>
    </div>
  </form>
</template>

<script>

export default {
  name: 'AdvProductPageSignature',
  props: {
    schema: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      signature: true,
      selection: 'general',
      maxCharacters: 60,
      rawInput: ''
    }
  },
  watch: {
    rawInput (newVal) {
      if (this.selection === 'specific') {
        this.schema.schema.groups[0].items[0].value = `${this.nominalDedicationText} ${newVal}`.trim()
      }
    },
    selection: {
      handler (value) {
        this.rawInput = ''
        if (value === 'general') {
          this.schema.schema.groups[0].items[0].value = this.generalDedicationText
        } else if (value === 'specific') {
          this.schema.schema.groups[0].items[0].value = this.nominalDedicationText
        }
      },
      immediate: true
    },
    signature: {
      handler (value) {
        const schema = JSON.parse(JSON.stringify(this.schema.schema))
        if (value) {
          schema.groups[0].items[0].value = this.generalDedicationText
        } else {
          schema.groups[0].items[0].value = ''
        }
        this.$set(this.schema, 'schema', schema)
      },
      immediate: true
    }
  },
  computed: {
    getSchema () {
      if (!this.schema || !('schema' in this.schema)) {
        return {
          groups: []
        }
      }

      return this.schema.schema
    },
    placeholder () {
      return `${this.maxCharacters} χαρακτήρες`
    },
    signatureName () {
      return this.schema.name
    },
    generalDedicationText () {
      return this.schema.schema.groups[0].items[0].name.el
    },
    nominalDedicationText () {
      return this.schema.schema.groups[0].items[0].options.preTypedText.value.el
    }
  },
  methods: {
    clearInput () {
      this.schema.schema.groups[0].items[0].value = ''
      this.rawInput = ''
    },
    validate () {
      return this.$refs.schemaForm.reportValidity()
    }
  }
}
</script>

<style lang="scss" scoped>
.toggle-switch {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
  margin: 0;
}
.toggle-switch input[type="checkbox"] {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider-round {
  position: absolute;
  cursor: pointer;
  top: 8px;
  right: 0;
  bottom: 0;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;
  height: 10px;
  width: 32px;
  background-color: #b71515;
}
.slider-round:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: -10px;
  bottom: -3px;
  background-color: black;
  transition: 0.4s;
  border-radius: 50%;
  box-shadow: 0 0 0 6px rgba(255, 0, 0, 0.4);
}
.toggle-switch input[type="checkbox"]:checked + .slider-round {
  background-color: #4c774b;
}
.toggle-switch input[type="checkbox"]:focus + .slider-round {
  box-shadow: 0 0 1px #4c774b;
}
.toggle-switch input[type="checkbox"]:checked + .slider-round:before {
  -webkit-transform: translateX(56px);
  -ms-transform: translateX(56px);
  transform: translateX(56px);
  box-shadow: 0 0 0 6px #4c774b99;
  left: -30px;
}
.checkbox-round-text {
  color: #231f20;
  font-size: 14px;
  padding-right: 65px;
  font-weight: 700;
}
.custom-control-input {
  width: 12px;
  height: 12px;
  @media (max-width: 1199px) {
    width: 20px;
    height: 20px;
  }
}
.custom-control-input:checked ~ .custom-control-label {
  &::after {
    background-image: none;
  }
}

.custom-radio-dioptra {
  margin: 0;
  display: grid;
  grid-template-columns: 12px 1fr;
  align-items: center;
  gap: 8px;
}

.custom-radio-dioptra input {
  display: none;
}

.custom-radio-dioptra .checkmark {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid #000;
  box-shadow: 0 0 2px #000;
  position: relative;
}

.custom-radio-dioptra input:checked + .checkmark::before {
  content: "";  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  background-color: #000;
  border-radius: 50%;
  right: 0;
  margin: 0 auto
}
.custom-radio-dioptra-text {
  color: #231f20;
  font-size: 14px;
  @media screen and (max-width:1199px) {
    font-size: 12px;
  }
}
.adv-product-page-signature-radio-buttons {
  display: grid;
  gap: 15px;
  margin-top: 20px;
}
.adv-product-page-signature-input-text {
  color: #231f20;
  font-size: 14px;
  padding-bottom: 10px;
  margin: 0;
  @media screen and (max-width:1199px) {
    font-size: 12px;
  }
}
.adv-product-page-signature-inputs {
  display: grid;
  gap: 15px;
}
.adv-product-page-signature-input-container {
  position: relative;
}
.adv-product-page-signature-input {
  width: 100%;
  padding: 10px;
  border: 1px solid #231F20;
  border-radius: unset;
  @media screen and (max-width:1199px) {
    font-size: 12px;
    padding: 15px;
    background: #F5F7F7;
    border: unset;
  }
}
.adv-product-page-signature-input-clear-button {
  color: white;
  background: #231F20;
  border: unset;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: grid;
  align-items: center;
  justify-items: center;
  align-content: center;
  padding: 0;
  position: absolute;
  top: 13px;
  right: 10px;
}
.adv-product-page-signature-input-submit-button {
  width: 100%;
  text-align: end;
  font-size: 12px;
  font-weight: 700;
  color: #231F20;
  background: transparent;
  border: unset;
  padding: 5px 0 0 0;
  display: block
}
.adv-product-page-signature {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  @media screen and (max-width:1199px) {
    padding-bottom: 20px;
  }
  &.mobile {
    @media screen and (min-width:1200px) {
      display: none;
    }
  }
  &.desktop {
    @media screen and (max-width:1199px) {
      display: none;
    }
  }
}
</style>
